import _ from '@lodash';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import KerdesTableDto from 'app/admin/kerdes/dto/KerdesTableDto';
import UserTableDto from 'app/admin/user/dto/UserTableDto';

export class ReviewTableDto extends IdentifiableDto {
	constructor() {
		super();

		/** @type {KerdesTableDto} */
		this.kerdes = null;

		/** @type {UserTableDto} */
		this.felhasznalo = null;
	}

	/**
	 * @typedef {Object} _ReviewTableDtoProps
	 * @property {KerdesTableDto} kerdes
	 * @property {UserTableDto} felhasznalo
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _ReviewTableDtoProps} ReviewTableDtoProps
	 */
	/**
	 *
	 * @param {ReviewTableDtoProps} props
	 * @returns {ReviewTableDto}
	 */
	setup(props) {
		super.setup(props);

		this.kerdes = props.kerdes !== null ? new KerdesTableDto().setup(props.kerdes) : null;
		this.felhasznalo = props.felhasznalo !== null ? new UserTableDto().setup(props.felhasznalo) : null;

		return this;
	}
}

export default ReviewTableDto;